import React, { Component } from 'react'
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { 
  Button,FormGroup,Checkbox,
  Intent, Spinner, RadioGroup, Radio, Icon
} from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import BookingDateTimeInput from 'components/BookingDateTimeInput';
import moment from 'moment';
import GeoComplete from '../../helpers/GeoComplete';
import { currencySymbol, currencyFormattedAmount } from 'helpers/currency';
import QuestionRadio from 'components/Booking/QuestionRadio';
import QuestionSelect from 'components/Booking/QuestionSelect';
import QuestionTextbox from 'components/Booking/QuestionTextbox';
import { hasGroupedQuestions,
  BookingPageHeader, BookingSection, BookingTicket, BookingAttachments,
  ServiceTypeSelectWrap, joinAddress, bookingBrandStyle
} from 'components/Booking/BookingLayout';
import BookingStepper from 'components/BookingModal/Stepper';
import { ChoiceGroup, ChoiceCard } from 'components/BookingModal/ChoiceCards';
import { normalizeHex } from 'helpers/serviceTypeColor';
import { bookingReference } from 'helpers/bookingReference';
import { flatOptionLabel, flatOptionQuantity } from 'helpers/bookingPricing';
import { CARD_PAYMENT_METHOD, cardCharge, cardPaymentsAvailable, isRecurringFrequency, payPublicBooking, paymentErrorMessage, recurringFrequencyChosen } from 'helpers/bookingCardPayment';
import BookingCardPayment from 'components/Booking/BookingCardPayment';

var startCountRange = 0
var label= '';
var indexChecked = '';
var selectedAnswer = '';
var url_string = window.location.href;
var url = new URL(url_string);
var is_brand = url.searchParams.get("is_brand");
var princingRangeCombineArray = [];

const items=[ 
  { label: 'Cash', value: 'Cash' }, 
  { label: 'Interac', value: 'Interac' },
  { label: 'Cheque', value: 'Cheque' },
  { label: 'Debit/Credit', value: 'dr/cr' }
];

@inject('bookingStore','viewStore','preferenceStore','serviceTypeStore','pricingParameterStore','frequencyStore','questionGroupStore','store','serviceTypeCategoryStore') @observer
class BookingNewPublicPage extends Component {
  @observable pricingParameterArray = [];

  @observable startCountRange = 0;
  @observable extra_service_total = 0;
  @observable pricing_parameter_total = 0;
  @observable pricing_range_total = 0;
  @observable grand_total = 0.0;
  @observable isServiceTypeChecked = 0;
  // Set once the booking is created: the page then shows the confirmation panel.
  @observable createdBookingId = null;
  // Card payments: the booking created but not paid yet (retry pays this one,
  // never a new booking), the payment in flight, its error, and what was paid.
  @observable paymentBookingId = null;
  @observable isPaying = false;
  @observable paymentError = null;
  @observable paidAmountCents = null;
  // The card field handle ({ stripe, card, isComplete }) and payment progress
  // for paymentBookingId. Plain fields: Stripe objects must not be observable.
  cardApi = null;
  paymentProgress = {};

  componentDidMount() {
    let {
      serviceTypeStore,
      questionGroupStore,
      serviceTypeCategoryStore,
      bookingStore:{
        booking:{
          object
        }
      }
    } = this.props;
    
    if(object && object.attributes){
      this.grand_total = object.attributes.total;
    }
    serviceTypeCategoryStore.loadServiceTypePublicCategories();
    questionGroupStore.loadPublicQuestionGroups();
    serviceTypeStore.loadPublicServiceTypesBooking();
    this.props.bookingStore.loadPublicPaymentSettings().catch(() => {});
    window.$crisp.push(['do', 'chat:hide']);
  }

  onAddressSelect(suggestion) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(suggestion) {
      object.attributes.address = suggestion.label;
      suggestion.gmaps && suggestion.gmaps.address_components && suggestion.gmaps.address_components.length > 0 && suggestion.gmaps.address_components.map((address_component) => {
        if(_.includes(address_component.types, "locality")) {
          object.attributes.city = address_component.long_name;
        }

        if(_.includes(address_component.types, "administrative_area_level_1")) {
          object.attributes.state = address_component.long_name;
        }
        
        if(_.includes(address_component.types, "postal_code")) {
          object.attributes.zip = address_component.long_name;
        }
      })
    } else {
      object.attributes.address = '';
      object.attributes.zip = "";
      object.attributes.state = "";
      object.attributes.city = "";
    }
  }

  onAddressClear(value) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(!value) {
      object.attributes.address = '';
    }
  }

  onExtraServiceSelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;

    let index = object.attributes.booking_service_type_extras.map(function(item) { return item.name; }).indexOf(selectedOptions.name);
    if(event.target.checked === true) {
      if(index === -1) { 
        object.attributes.booking_service_type_extras.push({service_type_extra_id:selectedOptions.id,name:selectedOptions.name,price:parseFloat(selectedOptions.price_cents/100)});
      } else {
        object.attributes.booking_service_type_extras[index].price = parseFloat(selectedOptions.price_cents/100);
        object.attributes.booking_service_type_extras[index]._destroy = 0;
      }
    } else{ 
      object.attributes.booking_service_type_extras[index].price = 0;
      object.attributes.booking_service_type_extras[index]._destroy = 1;
    }
    this.calculateGrandtotal()
  }

  onFrequencySelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    object.attributes.frequency_id = selectedOptions.id;
    // Cards are for one-time bookings only.
    if(isRecurringFrequency(selectedOptions) && object.attributes.payment_method === CARD_PAYMENT_METHOD) {
      object.attributes.payment_method = null;
    }
  }

  onPricingRangeSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    console.log('test')
    if(event.target.value != ''){
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.id;
        object.attributes.booking_pricing_parameters[index].name = event.target.options[event.target.selectedIndex].text;
        object.attributes.booking_pricing_parameters[index].price = parseFloat(event.target.value);
        object.attributes.booking_pricing_parameters[index].total_amount = parseFloat(event.target.selectedIndex) * parseFloat(event.target.value);

      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat(event.target.value),total_amount:parseFloat(event.target.value)});
      
      }
      this.calculateGrandtotal()
    }
  }

  onPricingRangeSelectImage(event,selectedOptions,key) { 
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;

    if(event.target.checked){
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.pricing_parameter_id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.pricing_parameter_id;
        object.attributes.booking_pricing_parameters[index].name = selectedOptions.label;
        object.attributes.booking_pricing_parameters[index].price = selectedOptions.price;
        object.attributes.booking_pricing_parameters[index].total_amount =  selectedOptions.price;
      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.pricing_parameter_id,name:selectedOptions.label,price:selectedOptions.price,total_amount:selectedOptions.price});
      }
      this.calculateGrandtotal()
    }
  }

  onPricingSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(event.target.value != ''){
      // Quantity is the number in the option label ("Tires x 4" is 4), as the server prices it.
      const quantity = flatOptionQuantity(flatOptionLabel(event));
      const amount = quantity * parseFloat((selectedOptions.price_cents/100));
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].name = event.target.value;
        object.attributes.booking_pricing_parameters[index].price = amount;
        object.attributes.booking_pricing_parameters[index].quantity = quantity;
        object.attributes.booking_pricing_parameters[index].total_amount = amount;
      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:event.target.value,quantity:quantity,total_amount:amount,price:amount});
      }
    } else {
      object.pricing_parameters = [];
    }
    this.calculateGrandtotal()
  }

  // The saved choice for a flat pricing parameter (e.g. "Tires x 3"), so its
  // select shows it. Saved bookings keep choices in booking_pricing_parameters,
  // new ones in pricing_parameters; both store the option text as `name`.
  selectedPricingLabel(pricing) {
    const { object } = this.props.bookingStore.booking;
    const attributes = (object && object.attributes) || {};
    // Option text has its whitespace collapsed by the browser (a name like
    // "Tires x " gives "Tires x  4" in code but "Tires x 4" as the option and
    // as the saved name), so compare and return the collapsed form.
    const tidy = (text) => String(text || '').replace(/\s+/g, ' ').trim();
    const saved = [...(attributes.booking_pricing_parameters || []), ...(attributes.pricing_parameters || [])]
      .map((item) => item && tidy(item.name));
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      const label = tidy(`${pricing.name} ${i}`);
      if (saved.includes(label)) return label;
    }
    return '';
  }

  pricingList = (pricing) => {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    let pricingToReturn = [];
    this.pricingParameterArray = [];
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      let label = `${pricing.name} ${i}`;
      let indexChecked = object.attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(label);
      if(indexChecked > -1){
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }else{
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }
    }
    return pricingToReturn;
  };

  pricingRangeList = (pricing) => {
    let {
      props: {
        pricingParameterStore,
        pricingParameterStore: {
          pricingParameterDetailUpdate: { 
            object
           }
        },
        bookingStore: {
          booking
        }
      }
    } = this;
    let pricingRangeToReturn = [];
    
    if(pricing.id){
      let index = pricing.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(pricing.id);
      if(index > -1){
        pricing.pricing_parameter_ranges.map((range) => {
          let label = `${range.label}`;
          let indexChecked = booking.object.attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(label);
          if(indexChecked > -1){
            console.log(range);
            pricingRangeToReturn.push(<option selected={'selected'} innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }else{
            console.log(range);
            pricingRangeToReturn.push(<option innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }
        });
      }
    }
    return pricingRangeToReturn;
  };

  handleStartDateChange(date) {
    let { object } = this.props.bookingStore.booking;
    if(date) {
      object.attributes.start_date = moment(date);
    }
  }

  onPaymentSelect = (event,payment,key) => {
    let { object } = this.props.bookingStore.booking;
    // The booking is already saved for a card payment: keep the choice.
    if(this.paymentBookingId || this.isPaying) return;
    this.paymentError = null;
    object.attributes.payment_method = payment.value;
  }

  onContactWayChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.contact_way = event.target.value;
  }

  onTimePeriodChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.start_project_expected_period = event.target.value;
  }

  onServiceTypeChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if(event.target.value !== "") {
      princingRangeCombineArray = [];
      this.isServiceTypeChecked = event.target.value;
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = event.target.value;
      serviceTypeStore.loadPublicServiceTypeDetail({uuid:event.target.value})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  onServiceTypeCategoryChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    this.props.viewStore.serviceTypeSearch.where.service_type_category_id = event.target.value;
    this.props.serviceTypeStore.loadServiceTypes() 
    object.attributes.service_type_category_id = event.target.value;
  }

  onServiceTypeSelect = (event,service,key) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if(service.attributes.id !== "") {
      this.isServiceTypeChecked = service.attributes.id;
      princingRangeCombineArray = [];
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = service.attributes.id;
      serviceTypeStore.loadPublicServiceTypeDetail({uuid:service.attributes.id})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    }else{
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  calculateGrandtotal() {
    let { 
      bookingStore: {
        booking: {
          object
        }
      },
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;

    object.attributes.total = 0.0;

    // Adding Service type price in grand total
    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      object.attributes.total += serviceTypeDetail.object.attributes.rate;
    }

    // Adding pricing parameters flat/ranges to grand total
    if(object && object.attributes.booking_pricing_parameters && object.attributes.booking_pricing_parameters.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_pricing_parameters, 'price')
    }

    // Adding extra service types to grand total
    if(object && object.attributes.booking_service_type_extras && object.attributes.booking_service_type_extras.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_service_type_extras, 'price')
    }
  }

  createBooking() {
    let {
      props: {
        store,
        bookingStore: {
          tenant,
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;

    if(this.isPaying) return;
    // The booking already exists and is waiting for its card payment: pay
    // that one again instead of creating a second booking.
    if(this.paymentBookingId) {
      this.retryPayment();
      return;
    }
    
    if(object.attributes.first_name === "" || object.attributes.first_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.last_name === "" || object.attributes.last_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.email === "" || object.attributes.email === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.phone === "" || object.attributes.phone === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.address === "" || object.attributes.address === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.city === "" || object.attributes.city === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.state === "" || object.attributes.state === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.zip === "" || object.attributes.zip === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.service_type_category_id === "" || object.attributes.service_type_category_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service category type!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
      return;
    }
    // if(object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
    //   Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
    //   return;
    // }
    // if(object.attributes.payment_method === "" || object.attributes.payment_method === null) {
    //   Toast.show({ icon: 'warning-sign', message: 'Please select payment method!', intent: Intent.DANGER })
    //   return;
    // }

    // Paying by card: the card must be filled in before the booking is sent.
    const payByCard = this.isCardPayment();
    if(payByCard) {
      if(!this.cardApi) {
        this.paymentError = 'The card field is still loading. Please wait a moment and try again.';
        return;
      }
      if(!this.cardApi.isComplete()) {
        this.paymentError = 'Enter your full card details.';
        Toast.show({ icon: 'warning-sign', message: 'Enter your full card details.', intent: Intent.DANGER });
        this.cardApi.focus();
        return;
      }
      this.paymentError = null;
      // Keeps the form (and the card field) on screen while the booking saves.
      this.isPaying = true;
    }

    object.attributes.booking_service_type_extras_attributes = object.attributes.booking_service_type_extras;
    object.attributes.booking_pricing_parameters_attributes = object.attributes.booking_pricing_parameters;
    object.attributes.status = 'draft';
    object.attributes.booking_questions_attributes = object.attributes.booking_questions;

    this.props.bookingStore
      .createPublicBooking(object)
      .then(response => {
        const created = response && response.data && response.data.data;
        const createdId = (created && (created.id || (created.attributes && created.attributes.id))) || true;
        if(payByCard && createdId !== true) {
          this.paymentBookingId = createdId;
          this.paymentProgress = {};
          this.runPayment(createdId);
          return;
        }
        if(payByCard) {
          // No booking id came back, so there is nothing to charge.
          this.isPaying = false;
          Toast.show({ icon: 'warning-sign', message: 'Your booking was sent, but we couldn\'t take the card payment. We\'ll be in touch about paying.', intent: Intent.WARNING });
        }
        if(!payByCard) {
          Toast.show({
            icon: "thumbs-up",
            message: 'Thanks, your booking was sent.',
            intent: Intent.SUCCESS
          });
        }
        store.isBookingConfirmDialog = true;
        this.createdBookingId = createdId;
      })
      .catch((error) => {
        this.isPaying = false;
        const message = (error && error.response && error.response.data && (error.response.data.errors || error.response.data.error)) || 'Your booking wasn\'t sent. Check your details and try again.';
        Toast.show({ icon: 'warning-sign', message: Array.isArray(message) ? message.join(', ') : String(message), intent: Intent.DANGER });
      });
  }

  // Card chosen, and the company takes cards.
  isCardPayment() {
    const { bookingStore } = this.props;
    const attributes = bookingStore.booking.object && bookingStore.booking.object.attributes;
    return Boolean(attributes && attributes.payment_method === CARD_PAYMENT_METHOD && cardPaymentsAvailable(bookingStore.paymentSettings));
  }

  // Charges the saved booking: payment_intent, Stripe confirmation, then
  // payment_confirmation. On failure the booking stays saved for a retry.
  runPayment(bookingId) {
    const { bookingStore, store } = this.props;
    this.isPaying = true;
    this.paymentError = null;
    payPublicBooking(bookingStore, this.cardApi, bookingId, this.paymentProgress)
      .then(({ amountCents }) => {
        this.isPaying = false;
        this.paidAmountCents = amountCents != null ? amountCents : null;
        this.paymentBookingId = null;
        Toast.show({ icon: "thumbs-up", message: 'Payment received. Thanks, your booking was sent.', intent: Intent.SUCCESS });
        store.isBookingConfirmDialog = true;
        this.createdBookingId = bookingId;
      })
      .catch((error) => {
        this.isPaying = false;
        this.paymentError = paymentErrorMessage(error);
        Toast.show({ icon: 'warning-sign', message: 'Your booking is saved, but the payment didn\'t go through.', intent: Intent.DANGER });
      });
  }

  onCardReady = (api) => {
    this.cardApi = api;
  }

  onCardChange = (change) => {
    // A complete card clears the "enter your card" message (not a payment error).
    if(change.complete && !this.paymentBookingId) this.paymentError = null;
  }

  retryPayment() {
    if(!this.paymentBookingId || this.isPaying) return;
    if(!this.paymentProgress.charged && !(this.cardApi && this.cardApi.isComplete())) {
      this.paymentError = 'Enter your full card details.';
      if(this.cardApi) this.cardApi.focus();
      return;
    }
    this.runPayment(this.paymentBookingId);
  }

  onChangeFile(event) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    var FileSize = event.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 10) {
      Toast.show({ icon: 'warning-sign', message: 'File size exceeds 10 MB!', intent: Intent.DANGER })
      return
    }
    this.props.bookingStore.uploadPublicBookingAttachment(event.target.files[0], attributes.id)
      .then(this.onSuccessfullUploadAttachment.bind(this))
      .catch(this.onFailUploadAttachment.bind(this))
  }

  onSuccessfullUploadAttachment(response) {
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.booking_attachment_ids.push(response.data.data.attributes.id);
    attributes.booking_attachments.push(response.data.data.attributes);
  }

  onFailUploadAttachment(error) {
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, failed to upload file!', intent: Intent.DANGER })
    }
  }

  removeAttachment(attachment) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    this.props.bookingStore.removePublicAttachment(attachment, attributes.id)
  }

  validate(bookingStep) {
    let {
      props: {
        bookingStore,
        bookingStore: {
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;
    if(bookingStep === 1){
      if(object.attributes.first_name === "" || object.attributes.first_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.last_name === "" || object.attributes.last_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.email === "" || object.attributes.email === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.phone === "" || object.attributes.phone === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 2){
      if(object.attributes.address === "" || object.attributes.address === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.city === "" || object.attributes.city === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.state === "" || object.attributes.state === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.zip === "" || object.attributes.zip === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 3){
      if(object.attributes.service_type_category_id === "" || object.attributes.service_type_category_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type category!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 4){
      // if(object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
      //   Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
      //   return false;
      // }
      return true;
    }
    if(bookingStep === 5){
      // if(object.attributes.payment_method === "" || object.attributes.payment_method === null) {
      //   Toast.show({ icon: 'warning-sign', message: 'Please select payment method!', intent: Intent.DANGER })
      //   return false;
      // }
      return true;
    }

  }

  navigateToNextScreen() {
    let {
      props: {
        bookingStore,
        bookingStore: {
          bookingStep,
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;
    let result = this.validate(bookingStore.bookingStep);
    if(bookingStep < 7 && result === true){
      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;

      bookingStore.bookingStep = bookingStep + 1;
      
      switch(bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true;
          break;
        case 2:
          bookingStore.bookingStep2 = true;
          break;
        case 3:
          bookingStore.bookingStep3 = true;
          break;
        case 4:
          bookingStore.bookingStep4 = true;
          break;
        case 5:
          bookingStore.bookingStep5 = true;
          break;
        case 6:
          bookingStore.bookingStep6 = true;
          break;
        default:
          // code block
      }
    }
  }

  navigateToPreviousScreen() {
    let {
      bookingStore,
      bookingStore:{
        bookingStep
      }
    } = this.props;
    if(bookingStep > 1){
      bookingStore.bookingStep = bookingStep - 1;

      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;
      switch(bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true
          break;
        case 2:
          bookingStore.bookingStep2 = true
          break;
        case 3:
          bookingStore.bookingStep3 = true
          break;
        case 4:
          bookingStore.bookingStep4 = true
          break;
        case 5:
          bookingStore.bookingStep5 = true
          break;
        case 6:
          bookingStore.bookingStep6 = true
          break;
        default:
          // code block
      }
    }
  }

  renderPricingParameters(pricing_parameters, attributes, keyed) {
    if(!(pricing_parameters && pricing_parameters.length > 0)) {
      return null;
    }
    // The select-style service list re-mounts these rows on every render
    // (random keys) so the `selected` options follow the booking; the icon
    // style never did. Both kept as they were.
    const rowKey = () => (keyed ? Math.random() : undefined);
    return (
      <div className="bk-pricing">
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing,pricingKey) => {
            if(pricing.pricing_type === 'flat'){
              return (
                <div className="bk-field" key={rowKey()}>
                  <FormGroup label={pricing.name || "Pricing"} labelFor="text-input">
                    <select
                      value={this.selectedPricingLabel(pricing)}
                      className='form-control'
                      placeholder={`Select ${pricing.name}`}
                      onChange={(event) => {this.onPricingSelect(event,pricing)} }
                    >
                      <option value="">Select one</option>
                    { this.pricingList(pricing)}
                    </select>
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing) => {
            if(pricing.pricing_type === 'range'){
              var index = pricing.pricing_parameter_ranges.length === _.filter(pricing.pricing_parameter_ranges, function(obj) { return obj.image_url; }).length
              return (
                <div className={index === true ? "bk-field bk-field--full" : "bk-field"} key={rowKey()}>
                  <FormGroup
                    label={pricing.name}
                    labelFor="text-input"
                  >
                    {
                      index === true ?
                      <div className="bk-image-options">
                        {pricing.pricing_parameter_ranges.map((pricing_range,key) => {
                          let indexChecked = attributes && attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(pricing_range.label);
                          var checked_id ='';
                          if(indexChecked > -1){
                            checked_id = pricing_range.id;
                          }
                          return (
                            <div className={`bk-image-option ${checked_id === pricing_range.id ? 'bk-image-option--active' : ''}`} key={pricing_range.id || key}>
                              <div className="bk-image-option__media">
                                <img src={pricing_range.image_url} alt="" />
                                <Radio type="radio" name="checkboxgroup"
                                  className="bk-image-option__radio"
                                  aria-label={pricing_range.label}
                                  checked={checked_id === pricing_range.id ? true: false}
                                  onChange={(event) => {this.onPricingRangeSelectImage(event,pricing_range,key)} }
                                />
                              </div>
                              <span className="bk-image-option__label">{pricing_range.label}</span>
                            </div>
                          )
                        })}
                      </div>:
                      <select
                        className='form-control'
                        placeholder={`Select ${pricing.name}`}
                        onChange={(event) => {this.onPricingRangeSelect(event,pricing)} }
                        >
                        <option value="">Select one</option>
                        { this.pricingRangeList(pricing)}
                      </select>
                    }
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
      </div>
    );
  }

  render() {
    let {
      store,
      serviceTypeStore: {
        serviceType:{
          objects
        },
        serviceTypeDetail,
      },
      bookingStore:{
        bookingStep,
        bookingStep1,
        bookingStep2,
        bookingStep3,
        bookingStep4,
        bookingStep5,
        bookingStep6,
        showUploadAttachmentLoader,
        tenant,
        tenant: {
          object
        },
        booking:{
          object: {
            attributes
          },
          isLoading
        }
      },
      questionGroupStore:{
        groups
      },
      serviceTypeCategoryStore:{
        serviceTypeCategories
      }
    } = this.props;

    let service_type_extra = [];
    let pricing_parameters = [];
    let frequency = [];
    let questions = [];

    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      service_type_extra = serviceTypeDetail.object.attributes.service_type_extra
      pricing_parameters = serviceTypeDetail.object.attributes.pricing_parameters
      frequency = serviceTypeDetail.object.attributes.frequency
      questions = serviceTypeDetail.object.attributes.questions;
    }

    // In this render `object` is the tenant (booking form settings, texts and
    // colours) and `attributes` is the booking being created.
    const tenantAttributes = (object && object.attributes) || {};
    const isWidget = tenantAttributes.booking_view_style === 'widget';
    const isBranded = is_brand === 'true';
    const showPrices = Boolean(tenantAttributes.enable_booking_price_display);
    const brandHex = normalizeHex(tenantAttributes.booking_form_color) || '#1800FF';
    const pageTitle = tenantAttributes.booking_page_title ? tenantAttributes.booking_page_title : 'Book a service';
    const confirmLabel = tenantAttributes.cta_title ? tenantAttributes.cta_title : 'Confirm booking';
    const paymentEnabled = tenantAttributes.payment_method === true;
    const stepLabels = ['Your details', 'Address', 'Service', 'Timing', paymentEnabled ? 'Payment' : 'Files', 'Note'];
    // Debit/Credit is offered only when the company takes cards online.
    const paymentSettings = this.props.bookingStore.paymentSettings;
    const cardsOn = paymentEnabled && cardPaymentsAvailable(paymentSettings) && !recurringFrequencyChosen(frequency, attributes && attributes.frequency_id);
    const paymentItems = cardsOn ? items : items.filter((payment) => payment.value !== CARD_PAYMENT_METHOD);
    const payByCard = Boolean(cardsOn && attributes && attributes.payment_method === CARD_PAYMENT_METHOD);
    const awaitingPayment = Boolean(this.paymentBookingId);
    const totalLabel = payByCard ? 'Total (charged when you book)' : 'Estimated total';
    // Step by step, the payment step stays mounted (hidden) after it so the
    // card field keeps its details until the booking is paid.
    const keepPaymentStep = isWidget && payByCard;

    const serviceDetailAttributes = serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes;
    const selectedServiceType = attributes && attributes.service_type_id && _.find(objects, (service) => service.attributes && String(service.attributes.id) === String(attributes.service_type_id));
    const serviceColor = (selectedServiceType && selectedServiceType.attributes.color) || (serviceDetailAttributes && serviceDetailAttributes.color);
    const customerName = attributes ? [attributes.first_name, attributes.last_name].filter((part) => part && String(part).trim() !== '').join(' ') : '';

    const ticketGroups = [];
    if(attributes && attributes.booking_pricing_parameters && attributes.booking_pricing_parameters.length > 0) {
      ticketGroups.push({
        key: 'pricing',
        title: tenantAttributes.pricing_title ? tenantAttributes.pricing_title : 'Pricing',
        lines: attributes.booking_pricing_parameters.map((parameter, index) => ({
          key: `pricing-${index}`,
          label: parameter.name,
          amount: showPrices && tenantAttributes.enable_booking_pricing_parameter ? currencyFormattedAmount((parameter.price)) : null
        }))
      });
    }
    if(service_type_extra && service_type_extra.length > 0 && attributes && attributes.booking_service_type_extras) {
      ticketGroups.push({
        key: 'extras',
        title: 'Add-ons',
        lines: attributes.booking_service_type_extras
          .filter((ext_service) => ext_service._destroy !== 1)
          .map((ext_service, index) => ({
            key: `extra-${index}`,
            label: ext_service.name,
            amount: showPrices ? currencyFormattedAmount(ext_service.price) : null
          }))
      });
    }

    // Paying by card: the company's default tax (HST...) is added and charged too.
    const charge = payByCard ? cardCharge(attributes && attributes.total, paymentSettings) : null;
    if(charge && charge.taxLabel) {
      ticketGroups.push({
        key: 'tax',
        title: 'Tax',
        lines: [{ key: 'tax', label: charge.taxLabel, amount: showPrices ? currencyFormattedAmount(charge.tax) : null }]
      });
    }
    const ticketTotal = charge ? charge.charge : (attributes && attributes.total);

    const confirmButton = (
      <Button
        className={attributes && attributes.status === 'confirmed' ? "bk-public__confirm disable-confirm-btn" : "bk-public__confirm"}
        intent={Intent.PRIMARY}
        onClick={this.createBooking.bind(this)}
        loading={isLoading && !this.isPaying}
        disabled={(attributes && attributes.status === 'confirmed') || this.isPaying ? true : false}
      >
        {this.isPaying ? 'Paying…' : (awaitingPayment ? 'Try payment again' : confirmLabel)}
      </Button>
    );

    const createdReference = this.createdBookingId && this.createdBookingId !== true ? bookingReference(this.createdBookingId) : null;

    return (
      <div
        className={`bk-page bk-public${isWidget ? ' bk-public--widget' : ''}`}
        style={bookingBrandStyle(tenantAttributes.booking_form_color, tenantAttributes.booking_form_bgcolor)}
      >
        <Helmet>
          <title>{tenantAttributes.booking_page_title ? tenantAttributes.booking_page_title : 'Book a service | FieldNexus'}</title>
        </Helmet>
        {/* The date picker opens in a portal outside this page, so it gets the brand colour here. */}
        <style dangerouslySetInnerHTML={{__html: `
          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background-color: ${brandHex} !important;
          }
        `}} />
        {/* While a card booking saves the form stays up: the card field must not unmount. */}
        {((isLoading && !this.isPaying) || tenant.isLoading) && <div className="spinner-center">
            <Spinner />
          </div>}
        {(!isLoading || this.isPaying) && !tenant.isLoading &&
          <React.Fragment>
            { isBranded ?
              <div className="bk-public__bar">
                <div className="bk-public__bar-inner">
                  <div className="bk-public__brand">
                    {tenantAttributes.logo && <img className="bk-public__logo" src={tenantAttributes.logo} alt={tenantAttributes.name || 'Company logo'} />}
                    {tenantAttributes.name && <span className="bk-public__name">{tenantAttributes.name}</span>}
                  </div>
                  <div className="bk-public__contacts">
                    { tenantAttributes.email &&
                      <a className="bk-public__contact" href={`mailto:${tenantAttributes.email}`}>
                        <Icon icon="envelope" iconSize={16} />
                        {tenantAttributes.email}
                      </a>
                    }
                    { tenantAttributes.phone &&
                      <a className="bk-public__contact" href={`tel:${tenantAttributes.phone}`}>
                        <Icon icon="phone" iconSize={16} />
                        {tenantAttributes.phone}
                      </a>
                    }
                  </div>
                </div>
              </div>
              :
              (tenantAttributes.logo || tenantAttributes.name) &&
              <div className="bk-public__bar bk-public__bar--plain">
                <div className="bk-public__bar-inner">
                  <div className="bk-public__brand">
                    {tenantAttributes.logo && <img className="bk-public__logo" src={tenantAttributes.logo} alt={tenantAttributes.name || 'Company logo'} />}
                    {tenantAttributes.name && <span className="bk-public__name">{tenantAttributes.name}</span>}
                  </div>
                </div>
              </div>
            }

            { this.createdBookingId ?
              <div className="bk-public__success" role="status">
                <span className="bk-public__success-check"><Icon icon="tick" iconSize={36} /></span>
                <h1 className="bk-public__success-title">
                  {tenantAttributes.booking_confirmation_message_title ? tenantAttributes.booking_confirmation_message_title : 'Thanks, your booking is in'}
                </h1>
                <p className="bk-public__success-text">
                  {tenantAttributes.booking_confirmation_message ? tenantAttributes.booking_confirmation_message : "We'll be in touch soon to confirm the details."}
                </p>
                {createdReference && <span className="bk-public__reference">Reference {createdReference}</span>}
                {this.paidAmountCents != null && <span className="bk-public__reference bk-public__paid">Paid {currencyFormattedAmount(this.paidAmountCents / 100)}</span>}
              </div>
              :
              <React.Fragment>
                <BookingPageHeader
                  title={pageTitle}
                  showStatus={false}
                  meta={tenantAttributes.booking_page_sub_title}
                />
                <div className={`bk-layout${bookingStep6 === true ? '' : ' bk-layout--single'}`}>
                  <div className="bk-form">
                    { isWidget &&
                      <BookingStepper steps={stepLabels} current={bookingStep || 1} />
                    }
                    {
                      bookingStep1 === true ?
                      <BookingSection number={1} title="Your details" helper="How we can reach you about this booking.">
                        <div className="bk-grid bk-grid--2">
                          <div className="bk-field">
                            <FormGroup
                              label={"First name"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='text'
                                className='form-control'
                                placeholder='First name'
                                autoComplete="given-name"
                                defaultValue={attributes && attributes.first_name}
                                onChange={(event) => {attributes.first_name = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Last name"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Last name'
                                autoComplete="family-name"
                                defaultValue={attributes && attributes.last_name}
                                onChange={(event) => {attributes.last_name = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Email"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='email'
                                className='form-control'
                                placeholder='you@example.com'
                                autoComplete="email"
                                defaultValue={attributes && attributes.email}
                                onChange={(event) => {attributes.email = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Phone"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='tel'
                                className='form-control'
                                placeholder='Ex. 9876543210'
                                autoComplete="tel"
                                defaultValue={attributes && attributes.phone}
                                onChange={(event) => {attributes.phone = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </BookingSection>
                      :''
                    }
                    {
                      bookingStep2 === true ?
                      <BookingSection number={2} title="Service address" helper="Where should we do the work?">
                        <div className="bk-grid bk-grid--address">
                          <div className="bk-field bk-field--address">
                            <FormGroup
                              label={"Address"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <GeoComplete
                                className='form-control geo-control'
                                placeholder="Start typing your address"
                                initialValue={attributes && attributes.address}
                                onSuggestSelect={this.onAddressSelect.bind(this)}
                                onChange={this.onAddressClear.bind(this)}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Address line 2"}
                              labelFor="text-input"
                            >
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Apartment, suite, unit'
                                autoComplete="address-line2"
                                defaultValue={attributes && attributes.suite}
                                onChange={(event) => {attributes.suite = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="bk-grid bk-grid--3">
                          <div className="bk-field">
                            <FormGroup
                              label={"City"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='text'
                                className='form-control'
                                placeholder='City'
                                autoComplete="address-level2"
                                value={(attributes && attributes.city) || ''}
                                onChange={(event) => {attributes.city = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"State or province"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='text'
                                className='form-control'
                                placeholder='State or province'
                                autoComplete="address-level1"
                                value={(attributes && attributes.state) || ''}
                                onChange={(event) => {attributes.state = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                          <div className="bk-field">
                            <FormGroup
                              label={"Zip or postal code"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Ex. 0377'
                                autoComplete="postal-code"
                                value={(attributes && attributes.zip) || ''}
                                onChange={(event) => {attributes.zip = event.target.value;}}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </BookingSection>
                      :''
                    }
                    {
                      bookingStep3 === true ?
                      <BookingSection
                        number={3}
                        title={tenantAttributes.heading_text_for_service_type ? tenantAttributes.heading_text_for_service_type : 'Choose a service'}
                        helper="Pick a category, then the service you need."
                      >
                        {
                          serviceTypeCategories.objects &&
                          <div className="bk-grid bk-grid--2">
                            <div className="bk-field">
                              <FormGroup label={'Category'} labelFor="text-input" labelInfo={"*"}>
                                <div className="bk-select">
                                  <select
                                    className='form-control'
                                    onChange={this.onServiceTypeCategoryChange.bind(this)}
                                  >
                                    <option value="">Select a category</option>
                                    { serviceTypeCategories.objects.map((category) => {
                                        return(
                                          <option value={category.attributes.id} key={category.attributes.id}>{category.attributes.name}</option>
                                        )
                                      })
                                    }
                                  </select>
                                  { serviceTypeCategories.objects.length === 0 ?
                                      <Spinner className="bk-select__spinner" size={Spinner.SIZE_SMALL} />
                                      :
                                      ""
                                  }
                                </div>
                              </FormGroup>
                            </div>
                          </div>
                        }
                        { object && object.attributes && object.attributes.display_service_type === 'Icon' && attributes.service_type_category_id != '' ?
                          <div className="bk-subsection">
                            <span className="bk-label">Service <span className="bp3-text-muted">*</span></span>
                            <ChoiceGroup label="Service" className="bk-choices">
                              { objects && objects.map((service,key) => {
                                if(service.attributes.display_on_booking_form) {
                                  const checked = this.isServiceTypeChecked == service.attributes.id;
                                  const accent = normalizeHex(service.attributes.color);
                                  return (
                                    <ChoiceCard
                                      key={service.attributes.id}
                                      className="bk-choice--service"
                                      checked={checked}
                                      style={accent ? { '--bk-service': accent } : undefined}
                                      onSelect={(event) => { if(!checked) { this.onServiceTypeSelect(event,service,key) } }}
                                    >
                                      <span className="bk-choice__check" aria-hidden="true"><Icon icon="tick" iconSize={10} /></span>
                                      {service.attributes.logo ?
                                        <span className="bk-choice__logo"><img src={service.attributes.logo} alt="" /></span>
                                        :
                                        <span className="bk-choice__dot" aria-hidden="true" />
                                      }
                                      <span className="bk-choice__name">{service.attributes.name}</span>
                                    </ChoiceCard>
                                    )
                                  }
                                })
                              }
                            </ChoiceGroup>
                            {this.renderPricingParameters(pricing_parameters, attributes, false)}
                          </div>
                          :
                          <div className="bk-subsection">
                            {attributes.service_type_category_id != '' ?
                              <div>
                                <div className="bk-grid bk-grid--2">
                                  <div className="bk-field">
                                    <FormGroup label={tenantAttributes.another_heading_text_for_service ? tenantAttributes.another_heading_text_for_service : 'Service'} labelFor="text-input" labelInfo={"*"}>
                                      <ServiceTypeSelectWrap color={serviceColor}>
                                        <select
                                          className='form-control'
                                          value={attributes && attributes.service_type_id || ""}
                                          onChange={this.onServiceTypeChange.bind(this)}
                                        >
                                          <option value="">Select a service</option>
                                          { objects && objects.map((service) => {
                                            if(service.attributes.display_on_booking_form) {
                                              return(
                                                <option
                                                  value={service.attributes.id}
                                                  key={service.attributes.id}
                                                >
                                                    {service.attributes.name}
                                                </option>
                                              )
                                            }
                                            })
                                          }
                                        </select>
                                      </ServiceTypeSelectWrap>
                                    </FormGroup>
                                  </div>
                                </div>
                                {this.renderPricingParameters(pricing_parameters, attributes, true)}
                              </div>
                              :
                              <p className="bk-hint">Choose a category to see its services.</p>
                            }
                          </div>
                        }

                        {service_type_extra && service_type_extra.length > 0 && <div className="bk-subsection">
                          <h3 className="bk-subsection__title">Add-ons</h3>
                          <div className="bk-cards">
                            {
                              service_type_extra.map((extra,key) => {
                                indexChecked = attributes.booking_service_type_extras.map(function(item) { return item._destroy !== 1 ? item.service_type_extra_id : ""; }).indexOf(extra.id);
                                if(indexChecked > -1){
                                  label = extra.id;
                                } else {
                                  label = ""
                                }
                                return (
                                  <div className={`bk-card ${label === extra.id ? 'bk-card--active' :''}`} key={Math.random()}>
                                    <span className="bk-card__icon">
                                      {extra.icon_file && extra.icon_file.thumb && extra.icon_file.thumb.url && <img src={extra.icon_file.thumb.url} alt="" />}
                                    </span>
                                    <span className="bk-card__label">{extra.name}</span>
                                    <Checkbox label="" type="checkbox"
                                      className="bk-card__control"
                                      aria-label={extra.name}
                                      defaultChecked={label === extra.id ? true : false}
                                      onChange={(event) => {this.onExtraServiceSelect(event,extra,key)} }
                                    />
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>}

                        {hasGroupedQuestions(groups, questions) && <div className="bk-subsection">
                          <h3 className="bk-subsection__title">A few more details</h3>
                          <div className="bk-questions">
                          {
                            groups.objects.map(function(group) {
                              var isInGroup = questions.map(function(item) { return item.question_group_id; }).indexOf(group.id);
                              if(isInGroup > -1) {
                                return(
                                  <div className="bk-question-group" key={group.id}>
                                    <h3 className="bk-subsection__title">{group.attributes.question}</h3>
                                    {questions && questions.length > 0 && questions.map((question, index) => {

                                      indexChecked = attributes.booking_questions.map(function(item) { return item.question_id; }).indexOf(question.id);
                                      if(indexChecked > -1){
                                        label = question.id;
                                        selectedAnswer = attributes.booking_questions[indexChecked].answer;
                                      } else {
                                        selectedAnswer = ""
                                      }
                                      if(group.attributes.id === question.question_group_id){
                                      return(
                                        <div className="bk-question" key={question.id || index}>
                                          <span className="bk-label">{question.field_label}</span>
                                          <div className="bk-question__answer">
                                            {question.field_type === "Checkbox" && <div>
                                              <RadioGroup inline={true} className="bk-radio-group" name="question_radio">
                                                {question.field_value && question.field_value.split(/\r?\n/).map((answer) => {
                                                  return(
                                                    <QuestionRadio
                                                      key={Math.random()}
                                                      inline= {true}
                                                      bookingStatus={''}
                                                      question={question}
                                                      answer={answer}
                                                      checkedValue={label}
                                                      selectedAnswer={selectedAnswer}
                                                    />
                                                  )
                                                })}
                                              </RadioGroup>
                                              </div>}
                                              {question.field_type === "Dropdown"  && <div className="bk-question__control">
                                                <QuestionSelect
                                                  inline= {true}
                                                  question={question}
                                                  bookingStatus={''}
                                                  checkedValue={label}
                                                  selectedAnswer={selectedAnswer}
                                                />
                                              </div>}
                                              {question.field_type === "Textbox"  && <div className="bk-question__control">
                                                <QuestionTextbox
                                                  inline= {true}
                                                  question={question}
                                                  bookingStatus={''}
                                                  selectedAnswer={selectedAnswer}
                                                />
                                              </div>}
                                          </div>
                                        </div>
                                      )}})
                                    }
                                  </div>
                                )
                              }
                            })
                          }
                          </div>
                        </div>
                        }
                      </BookingSection>
                      :''
                    }
                    {
                      bookingStep4 === true ?
                      <BookingSection number={4} title="Timing" helper="When would you like to get started?">
                        <div className="bk-grid bk-grid--2">
                          {object && object.attributes && object.attributes.start_project_expected_period && (
                          <div className="bk-field">
                            <FormGroup label={"How soon would you like to start?"} labelFor="text-input">
                              <select
                                className='form-control'
                                placeholder={`Select `}
                                onChange={this.onTimePeriodChange.bind(this)}
                                defaultValue={attributes && attributes.start_project_expected_period}
                              >
                                <option value="">Select one</option>
                                {object && object.attributes && object.attributes.start_project_expected_period && object.attributes.start_project_expected_period.split(/\r?\n/).map((period) => {
                                  return(
                                    <option value={period.split(":")[1]}>{period.split(":")[0]}</option>
                                  )})}
                              </select>
                            </FormGroup>
                          </div>
                          )}
                          {object && object.attributes && object.attributes.contact_way && (
                          <div className="bk-field">
                            <FormGroup label={"How should we contact you?"} labelFor="text-input">
                              <select
                                className='form-control'
                                placeholder={`Select `}
                                onChange={this.onContactWayChange.bind(this)}
                                defaultValue={attributes && attributes.contact_way}
                              >
                                <option value="">Select one</option>
                                {object && object.attributes && object.attributes.contact_way && object.attributes.contact_way.split(/\r?\n/).map((way) => {
                                  return(
                                    <option value={way.split(":")[1]}>{way.split(":")[0]}</option>
                                  )})}
                              </select>
                            </FormGroup>
                          </div>
                          )}
                        </div>
                        {object && object.attributes && object.attributes.enable_visit_us === true &&
                          <div className="bk-subsection">
                            <div className="bk-grid bk-grid--2">
                              <div className="bk-field booking_form_date">
                                <FormGroup
                                  label={"When would you like us to visit?"}
                                  labelFor="text-input"
                                  labelInfo={"*"}
                                >
                                  <BookingDateTimeInput
                                    placeholder={'Pick a date'}
                                    defaultValue={attributes && attributes.start_date && moment(attributes.start_date)}
                                    onChange={this.handleStartDateChange.bind(this)}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        }
                        {object && object.attributes && object.attributes.enable_often_visit_us === true &&
                          <div>
                            {frequency && frequency.length > 0 && <div className="bk-subsection">
                              <span className="bk-label">How often should we visit?</span>
                              <div className="bk-chips">
                                {
                                  frequency.map((freqncy,frequencyKey) => {
                                    if(attributes && attributes.frequency_id){
                                      label = attributes.frequency_id;
                                    }
                                    return (
                                      <button
                                        type="button"
                                        key={Math.random()}
                                        aria-pressed={label == freqncy.id ? 'true' : 'false'}
                                        onClick={(event) => {this.onFrequencySelect(event,freqncy,frequencyKey)} }
                                        className={`bk-chip ${label == freqncy.id ? 'bk-chip--active' : ''}`}
                                      >
                                        {freqncy.title}
                                      </button>
                                    )
                                  })
                                }
                              </div>
                            </div>}
                          </div>
                        }
                      </BookingSection>
                      :''
                    }
                    {
                      bookingStep5 === true || keepPaymentStep ?
                      <BookingSection
                        className={bookingStep5 !== true && !this.paymentError ? 'bk-section--parked' : undefined}
                        number={5}
                        title={paymentEnabled ? 'Payment and files' : 'Photos and files'}
                        helper={paymentEnabled ? 'How you would like to pay, plus any photos or documents that help us.' : 'Add photos or documents that help us understand the job. Optional, up to 10 MB each.'}
                      >
                        {object && object.attributes && object.attributes.payment_method === true &&
                          <div className="bk-field">
                            <span className="bk-label">Payment method</span>
                            <div className="bk-chips">
                              {
                                paymentItems.map((payment,paymentKey) => {
                                  if(attributes && attributes.payment_method){
                                    label = attributes.payment_method;
                                  }
                                  return (
                                    <button
                                      type="button"
                                      key={Math.random()}
                                      aria-pressed={label === payment.value ? 'true' : 'false'}
                                      onClick={(event) => {this.onPaymentSelect(event,payment,paymentKey)} }
                                      className={`bk-chip ${label === payment.value ? 'bk-chip--active' : ''}`}
                                    >
                                      {payment.label}
                                    </button>
                                  )
                                })
                              }
                            </div>
                          </div>
                        }
                        {payByCard &&
                          <div className="bk-subsection">
                            <BookingCardPayment
                              stripeAccount={paymentSettings.stripe_account}
                              onReady={this.onCardReady}
                              onChange={this.onCardChange}
                              busy={this.isPaying}
                              error={this.paymentError}
                              amountLabel={currencyFormattedAmount(ticketTotal)}
                              onRetry={awaitingPayment ? this.retryPayment.bind(this) : null}
                              retrying={this.isPaying}
                              charged={Boolean(this.paymentProgress.charged)}
                            />
                          </div>
                        }
                        <div className={paymentEnabled ? 'bk-subsection' : ''}>
                          <BookingAttachments
                            title="Add photos or files (optional)"
                            attachments={attributes && attributes.booking_attachments}
                            uploading={showUploadAttachmentLoader}
                            onChange={this.onChangeFile.bind(this)}
                            onRemove={(attachment) => this.removeAttachment(attachment)}
                          />
                        </div>
                      </BookingSection>
                      :''
                    }
                    {
                      bookingStep6 === true ?
                      <BookingSection number={6} title="Anything else?" helper="Add a note for our team if there is something we should know. Optional.">
                        <div className="bk-field">
                          <textarea
                            type='text'
                            className='form-control'
                            placeholder='Type here...'
                            aria-label="Note"
                            value={attributes && attributes.note || ""}
                            onChange={(event) => {attributes.note = event.target.value;}}
                          />
                        </div>
                      </BookingSection>
                      :''
                    }

                    { object && object.attributes && object.attributes.booking_view_style === 'widget' &&
                      <div className="bk-public__nav">
                        <Button
                          className="bk-public__nav-prev"
                          icon="arrow-left"
                          disabled={(bookingStep && bookingStep === 1) || awaitingPayment || this.isPaying ? true : false}
                          onClick={this.navigateToPreviousScreen.bind(this)}
                          style={{display:`${bookingStep && bookingStep === 1 ? 'none' :'block'}`}}
                        >
                          Back
                        </Button>
                        <Button
                          className="bk-public__nav-next"
                          intent={Intent.PRIMARY}
                          rightIcon="arrow-right"
                          onClick={this.navigateToNextScreen.bind(this)}
                          disabled={bookingStep && bookingStep === 6 ? true : false}
                          style={{display:`${bookingStep && bookingStep === 6 ? 'none' :'block'}`}}
                        >
                          Continue
                        </Button>
                      </div>
                    }
                  </div>

                  { bookingStep6 === true ?
                    <div className="bk-aside">
                      <BookingTicket
                        date={attributes && attributes.start_date}
                        customerName={customerName}
                        contact={attributes && [attributes.email, attributes.phone].filter((part) => part).join(', ')}
                        address={attributes && attributes.address ? joinAddress(attributes.address, attributes.suite, attributes.city, attributes.state, attributes.zip) : null}
                        serviceName={serviceDetailAttributes ? serviceDetailAttributes.name : null}
                        serviceDetail={serviceDetailAttributes && showPrices ? `1 × ${currencyFormattedAmount(parseFloat(serviceDetailAttributes.rate))}` : null}
                        serviceAmount={serviceDetailAttributes && showPrices ? currencyFormattedAmount(serviceDetailAttributes.rate) : null}
                        serviceColor={serviceColor}
                        groups={ticketGroups}
                        showTotal={showPrices}
                        totalLabel={totalLabel}
                        total={currencyFormattedAmount(ticketTotal)}
                      >
                        {confirmButton}
                      </BookingTicket>
                    </div>
                    :''
                  }
                </div>

                { bookingStep6 === true &&
                  <div className="bk-public__mobile-bar">
                    {showPrices &&
                      <span className="bk-public__mobile-total">
                        {totalLabel}
                        <strong>{currencyFormattedAmount(attributes && attributes.total)}</strong>
                      </span>
                    }
                    {confirmButton}
                  </div>
                }
              </React.Fragment>
            }
          </React.Fragment>
        }
      </div>
    );
  }

};
export default BookingNewPublicPage;
